export default {
	validateRequestCancellationResult : null,
	cancellationSetting : null,
}